import styled from "styled-components";
import Form from "../../../UI/Form/Form";

export const StyledForm = styled(Form)``;
